if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      const button = this.querySelector('button[aria-controls]');
      const panel = this.querySelector('.disclosure__list-wrapper');
      const input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (!form || !button || !panel || !input) return;
      this.initialized = true;
      const close = () => { panel.hidden = true; button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); button.focus(); }
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) close();
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) close();
      });
      this.querySelectorAll('a[data-value]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          input.value = link.dataset.value;
          const url = new URL(window.location.href);
          if (this.dataset.previewThemeId) url.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
          let returnTo = form.querySelector('input[name="return_to"]');
          if (!returnTo) {
            returnTo = document.createElement('input');
            returnTo.type = 'hidden';
            returnTo.name = 'return_to';
            form.appendChild(returnTo);
          }
          returnTo.value = url.pathname + url.search;
          form.submit();
        });
      });
    }
  });
}
